
/**
 * OnePin Life API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
/**
 * Account interface.
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * @type {string}
     * @memberof Account
     */
    id: string;
    /**
     * @type {string}
     * @memberof Account
     */
    msisdn: string;
    /**
     * @type {AccountStatus}
     * @memberof Account
     */
    status?: AccountStatus;
    /**
     * @type {Date}
     * @memberof Account
     */
    createdAt?: Date;
    /**
     * @type {Date}
     * @memberof Account
     */
    activatedAt?: Date;
    /**
     * @type {Date}
     * @memberof Account
     */
    updatedAt?: Date;
    /**
     * @type {number}
     * @memberof Account
     */
    invitationCount?: number;
    /**
     * @type {ContactInfo}
     * @memberof Account
     */
    contactInfo?: ContactInfo;
}

/**
 * AuthenticationRequest interface.
 * @export
 * @interface AuthenticationRequest
 */
export interface AuthenticationRequest {
    /**
     * Unique identifier of the request.
     * @type {string}
     * @memberof AuthenticationRequest
     */
    requestId: string;
    /**
     * The MSISDN (mobile number).
     * @type {string}
     * @memberof AuthenticationRequest
     */
    msisdn: string;
}

/**
 * AuthenticationResult interface.
 * @export
 * @interface AuthenticationResult
 */
export interface AuthenticationResult {
    /**
     * @type {AuthenticationResultStatus}
     * @memberof AuthenticationResult
     */
    status: AuthenticationResultStatus;
    /**
     * JWT token.
     * @type {string}
     * @memberof AuthenticationResult
     */
    jwt: string;
    /**
     * The related account ID.
     * @type {string}
     * @memberof AuthenticationResult
     */
    accountId: string;

    /**
     * status message on failure.
     * @type {string}
     * @memberof AuthenticationResult
     */
    statusMessage?: string;
}

/**
 * ContactInfo interface.
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * @type {string}
     * @memberof ContactInfo
     */

    name: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    msisdn: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    additionalPhoneNumber?: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    photoId?: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    email?: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    title: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    location?: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    address?: string;
    /**
     * @type {string}
     * @memberof ContactInfo
     */
    birthday?: string;
    /**
     * @type {SocialMedia}
     * @memberof ContactInfo
     */
    socialMedia?: SocialMedia;
}

export interface SharedContactInfo {
    contactInfo: ContactInfo,
    senderAccountId: string,
    recipientMsisdn: string,
    createdAt: string
}

/**
 * ContactInfoSentEvent interface.
 * @export
 * @interface ContactInfoSentEvent
 */
export interface ContactInfoSentEvent {
    /**
     * Date and time of the event.
     * @type {Date}
     * @memberof ContactInfoSentEvent
     */
    eventDateTime: Date;
    /**
     * CXNPI id of the sender subscriber.
     * @type {number}
     * @memberof ContactInfoSentEvent
     */
    senderSubscriberId: number;
    /**
     * @type {Msisdn}
     * @memberof ContactInfoSentEvent
     */
    senderMsisdn: Msisdn;
    /**
     * @type {ContactInfo}
     * @memberof ContactInfoSentEvent
     */
    contactInfo?: ContactInfo;
    /**
     * CXNPI id of the recipient subscriber, required when recipient is an in-network subscriber.
     * @type {number}
     * @memberof ContactInfoSentEvent
     */
    recipientSubscriberId?: number;
    /**
     * @type {Msisdn}
     * @memberof ContactInfoSentEvent
     */
    recipientMsisdn: Msisdn;
    /**
     * The status of the recipient subscriber.
     * @type {boolean}
     * @memberof ContactInfoSentEvent
     */
    recipientSubscriberEnabled?: boolean;
    /**
     * Unique message tracking id set by CXNPI.
     * @type {number}
     * @memberof ContactInfoSentEvent
     */
    messageSessionId: number;
}

/**
 * EngagementResult interface.
 * @export
 * @interface EngagementResult
 */
export interface EngagementResult {
    /**
     * If this is an engagement related response, this value identifies the Engagement ID.
     * @type {number}
     * @memberof EngagementResult
     */
    engagementId: number;
    /**
     * @type {Msisdn}
     * @memberof EngagementResult
     */
    msisdn: Msisdn;
    /**
     * ICCID of subscribers (U)SIM card.
     * @type {string}
     * @memberof EngagementResult
     */
    iccid: string;
    /**
     * @type {HandsetOS}
     * @memberof EngagementResult
     */
    handsetOS: HandsetOS;
    /**
     * Date and time of the engagement result.
     * @type {Date}
     * @memberof EngagementResult
     */
    resultDateTime: Date;
    /**
     * @type {EngagementResultStatus}
     * @memberof EngagementResult
     */
    engagementResultStatus: EngagementResultStatus;
    /**
     * If this engagement result is related to an Engagement that expects to receive a response from the subscriber,
     * the subscriber's response value is defined under responseText.
     * @type {string}
     * @memberof EngagementResult
     */
    responseText?: string;
}

/**
 * EngagementResults interface.
 * @export
 * @interface EngagementResults
 */
export interface EngagementResults {
    /**
     * List of engagement result objects that are submitted to the client callback.
     * @type {Array<EngagementResult>}
     * @memberof EngagementResults
     */
    data?: Array<EngagementResult>;
}

/**
 * Mobile number in MSISDN format.
 * @export
 */
export type Msisdn = string;

/**
 * MsisdnSwapEvent interface.
 * @export
 * @interface MsisdnSwapEvent
 */
export interface MsisdnSwapEvent {
    /**
     * @type {string}
     * @memberof MsisdnSwapEvent
     */
    oldMsisdn: string;
    /**
     * @type {string}
     * @memberof MsisdnSwapEvent
     */
    newMsisdn: string;
    /**
     * @type {Date}
     * @memberof MsisdnSwapEvent
     */
    swapDateTime: Date;
}

/**
 * RetirementEvent interface.
 * @export
 * @interface RetirementEvent
 */
export interface RetirementEvent {
    /**
     * @type {string}
     * @memberof RetirementEvent
     */
    msisdn: string;
    /**
     * @type {Date}
     * @memberof RetirementEvent
     */
    retirementDate: Date;
}

/**
 * SocialMedia interface.
 * @export
 * @interface SocialMedia
 */
export interface SocialMedia {
    /**
     * @type {string}
     * @memberof SocialMedia
     */
    instagram?: string;
    /**
     * @type {string}
     * @memberof SocialMedia
     */
    facebook?: string;
    /**
     * @type {string}
     * @memberof SocialMedia
     */
    linkedin?: string;
    /**
     * @type {string}
     * @memberof SocialMedia
     */
    tiktok?: string;
}

/**
 * Stats interface.
 * @export
 * @interface Stats
 */
export interface Stats {
    /**
     * @type {Msisdn}
     * @memberof Stats
     */
    msisdn?: Msisdn;
    /**
     * @type {string}
     * @memberof Stats
     */
    accountId?: string;
    /**
     * @type {StatsType}
     * @memberof Stats
     */
    statsType?: StatsType;
}

/**
 * TokenResult interface.
 * @export
 * @interface TokenResult
 */
export interface TokenResult {
    /**
     * @type {string}
     * @memberof TokenResult
     */
    jwt?: string;
    /**
     * The related account ID.
     * @type {string}
     * @memberof TokenResult
     */
    accountId?: string;
}

enum LinkType {
    INVITATION,
    VIEW,
    CONFIRMATION
}

export interface TokenLink {
    token: string
	transactionId: string
	accountId: string
	recipientMsisdn: string;
	createdAt: string
	linkType: LinkType
	ttl: number
}

/**
 * Transaction interface.
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * @type {string}
     * @memberof Transaction
     */
    transactionId?: string;
    /**
     * @type {string}
     * @memberof Transaction
     */
    senderAccountId?: string;
    /**
     * @type {string}
     * @memberof Transaction
     */
    recipientMsisdn?: string;
    /**
     * @type {Date}
     * @memberof Transaction
     */
    createdAt?: string;
    /**
     * @type {ContactInfo}
     * @memberof Transaction
     */
    contactInfo?: ContactInfo;
}

/**
 * ---------------------------------------------------------------------------
 * Simplified Enums
 * ---------------------------------------------------------------------------
 */

/**
 * Account Status
 * @export
 * @enum {string}
 */
export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    RETIRED = 'RETIRED',
    DELETED = 'DELETED'
}

/**
 * Authentication Result Status
 * @export
 * @enum {string}
 */
export enum AuthenticationResultStatus {
    SUCCESS = 'SUCCESS',
    PENDING = 'PENDING',
    FAILED = 'FAILED'
}

/**
 * Engagement Result Status
 * @export
 * @enum {string}
 */
export enum EngagementResultStatus {
    RESPONSE_RECEIVED_SUCCESS = 'RESPONSE_RECEIVED_SUCCESS',
    RESPONSE_RECEIVED_CANCEL = 'RESPONSE_RECEIVED_CANCEL',
    RESPONSE_RECEIVED_BACK = 'RESPONSE_RECEIVED_BACK',
    RESPONSE_RECEIVED_PERMANENT_ERROR = 'RESPONSE_RECEIVED_PERMANENT_ERROR',
    RESPONSE_RECEIVED_TEMPORARY_ERROR = 'RESPONSE_RECEIVED_TEMPORARY_ERROR',
    RESPONSE_RECEIVED_TIMEOUT = 'RESPONSE_RECEIVED_TIMEOUT',
    RESPONSE_RECEIVED_USER_HELP_REQUESTED = 'RESPONSE_RECEIVED_USER_HELP_REQUESTED',
    RESPONSE_NOT_RECEIVED = 'RESPONSE_NOT_RECEIVED',
    REJECTED_UNSUPPORTED_MSISDN = 'REJECTED_UNSUPPORTED_MSISDN',
    REJECTED_SYSTEM_ERROR = 'REJECTED_SYSTEM_ERROR'
}

/**
 * Handset Operating System.
 * @export
 * @enum {string}
 */
export enum HandsetOS {
    Android = 'Android',
    iOS = 'iOS',
    Symbian = 'Symbian',
    Unknown = 'Unknown'
}

/**
 * Stats Type.
 * @export
 * @enum {string}
 */
export enum StatsType {
    CONTACT_INFO_DOWNLOADED = 'CONTACT_INFO_DOWNLOADED',
    INVITATION_LINK_FOLLOWED = 'INVITATION_LINK_FOLLOWED',
    CONFIRMATION_LINK_FOLLOWED = 'CONFIRMATION_LINK_FOLLOWED'
}
